<template>
  <el-form ref="form"
           :model="form"
           style="padding:20px;background:#fff"
           label-width="220px">
    <p class="title">电价交易情况</p>
    <el-row :gutter="80">
      <el-col :span="12">
        <el-form-item label="交易日期："
                      prop="tradeDate"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-date-picker v-model="form.tradeDate"
          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="用户直接交易购电结算电价："
                      prop="directPrice"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.directPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="峰平谷："
                      prop="fengpinggu"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-select v-model="form.fengpinggu"
                     placeholder="请选择峰平谷">
            <el-option label="峰"
                       :value="1"></el-option>
            <el-option label="平"
                       :value="2"></el-option>
            <el-option label="谷"
                       :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="目录电价(元)：">
          <el-input v-model="form.cataloguePrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="电量(kW·h)："
                      prop="eleQuantity"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.eleQuantity" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="市场电价(元)："
                      prop="marketPrice"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.marketPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="所在省燃煤机组标杆上网电价(元)："
                      prop="netPrice"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.netPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="零售电价(元)："
                      prop="retailPrice"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.retailPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="直接交易价格(元)："
                      prop="directTransactionPrice"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.directTransactionPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="价差(元)："
                      prop="priceDiff"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.priceDiff" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="输配电价(元)：">
          <el-input v-model="form.transDistPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="节约费用 (元)："
                      prop="costSaving"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.costSaving" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="政府基金及附加："
                      prop="fundAdd"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.fundAdd"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="偏差费用："
                      prop="diffCost"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.diffCost" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="区域电网输电容量电价(元)："
                      prop="areaPrice"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.areaPrice"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="偏差电量(kW·h)："
                      prop="diffQuantity"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.diffQuantity" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="ax_default line"></div>
    <el-form-item>
      <div style="text-align:center">
        <el-button @click="$router.back()"
                   style="margin-right:60px">取消</el-button>
        <el-button @click="submitForm('form')"
                   type="primary">保存</el-button>
      </div>

    </el-form-item>
  </el-form>
</template>
<script>
import { postClientElePriceInfos, putClientElePriceInfos } from '../../API'
export default {
  data () {
    return {
      form: {
        areaPrice: '',
        cataloguePrice: '',
        clientId: '',
        costSaving: '',
        diffCost: '',
        diffQuantity: '',
        directPrice: '',
        directTransactionPrice: '',
        elePriceInfoId: '',
        eleQuantity: '',
        fengpinggu: '',
        fundAdd: '',
        marketPrice: '',
        netPrice: '',
        priceDiff: '',
        retailPrice: '',
        tradeDate: '',
        transDistPrice: '',
      }
    }
  },
  created () {
    if (localStorage.getItem('djxx')) {
      this.form = JSON.parse(localStorage.getItem('djxx'))
    }
  },
    destroyed() {
    localStorage.removeItem('djxx')
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('elePriceInfoId') >= 0) {
            let params = this.form;
            params.clientId = localStorage.getItem('id')
            putClientElePriceInfos(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                     let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
          else {
            let params = this.form;
            params.clientId = localStorage.getItem('id')
            params.fengpinggu=1
            postClientElePriceInfos(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                     let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.el-row {
  margin: 0 !important;
}
.title {
  margin: 10px 0;
  color: #666;
}
.text {
  font-weight: 650;
  font-style: normal;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid rgb(228, 228, 228);
  text-align: center;
  line-height: normal;
  margin-bottom: 10px;
  margin-left: -20px;
  margin-right: -20px;
}
.line {
  height: 1px;
}
/deep/ .el-input{
  width: 200px;
}
</style>